import ContentLoader from 'react-content-loader'
import clsx from 'clsx'
import { Media } from '~/lib/Media'

type Props = {
  className?: string
}

export const ItemLoading = ({ className }: Props) => {
  const loop = [0, 1, 3]

  return (
    <aside className={clsx('w-full pt-4', className)}>
      <ul className={clsx('grid')}>
        {loop.map((i) => (
          <li key={i} className="">
            <Media lessThan="lg">
              <ContentLoader
                speed={3.3}
                viewBox="0 0 1440 150"
                backgroundColor="#F4F4F4"
                foregroundColor="#CACACA"
                gradientRatio={1}
              >
                <rect x="0" y="32" rx="0" ry="0" width="100" height="100" />
                <rect x="116" y="32" rx="0" ry="0" width="400" height="24" />
                <rect x="116" y="74" rx="0" ry="0" width="200" height="24" />
                <rect x="1194" y="63" rx="0" ry="0" width="109" height="24" />
                <rect x="1360" y="63" rx="0" ry="0" width="80" height="24" />
              </ContentLoader>
            </Media>
            <Media greaterThan="lg">
              <ContentLoader
                speed={3.3}
                viewBox="0 0 375 80"
                backgroundColor="#F4F4F4"
                foregroundColor="#CACACA"
                gradientRatio={1}
              >
                <rect x="0" y="0" rx="0" ry="0" width="75" height="75" />
                <rect x="120" y="8" rx="0" ry="0" width="140" height="22" />
                <rect x="120" y="34" rx="0" ry="0" width="100" height="22" />

                <rect x="286" y="14" rx="0" ry="0" width="42" height="20" />
                <rect x="340" y="14" rx="0" ry="0" width="32" height="20" />
              </ContentLoader>
            </Media>
          </li>
        ))}
      </ul>
    </aside>
  )
}
